import { render, staticRenderFns } from "./QuestionImport.vue?vue&type=template&id=163d67e4&scoped=true"
import script from "./QuestionImport.vue?vue&type=script&lang=js"
export * from "./QuestionImport.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163d67e4",
  null
  
)

export default component.exports